<template>
  <div class="zPanelimg-parent">
    <div
      v-if="show"
      :class="prefixCls"
      v-viewer
      :style="{'width': width + 'px', 'height': height + 'px', 'line-height': height + 'px'}"
    >
      <div v-if="disabled" class="disabled-item">
        <span>失效</span>
      </div>
      <img :src="src" alt :class="cover ? 'img-cover' : ''">
      <i v-if="del && !disabled" @click="deleteHandle" class="iconfont icon-trash"></i>
      <span v-if="choice" class="choice_product">精选</span>
      <span v-if="newProduct" class="new_product">New</span>
    </div>
    <div
      v-else
      :class="[prefixCls, 'no-viewer']"
      :style="{'background':colorDefault, 'width': width + 'px', 'height': height + 'px', 'line-height': height + 'px'}"
    >
      <div v-if="disabled" class="disabled-item">
        <span>产品失效</span>
      </div>
      <img :src="src" :class="cover ? 'img-cover' : ''" alt>
      <i v-if="del && !disabled" @click="deleteHandle" class="iconfont icon-trash"></i>
      <span v-if="choice" class="choice_product">精选</span>
      <span v-if="newProduct" class="new_product">New</span>
    </div>
  </div>
</template>
<script>
const prefixCls = "zPanelimg";
export default {
  name: "ZPanelimg",
  data() {
    return {
      prefixCls: prefixCls
    };
  },
  props: {
    colorDefault: {
      type: String
    },
    src: {
      type: String
    },
    width: {
      type: [String, Number],
      default: 60
    },
    height: {
      type: [String, Number],
      default: 60
    },
    // 是否需要 viewer
    show: {
      type: Boolean,
      default: true
    },
    // 是否可以删除
    del: {
      type: Boolean,
      default: true
    },
    // 是否失效
    disabled: {
      type: Boolean,
      default: false
    },
    cover: {
      type: Boolean,
      default: false
    },
    // 是否精选
    choice: {
      type: Boolean,
      default: false
    },
    // 是否是新增产品
    newProduct: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    deleteHandle() {
      this.$emit("delete");
    }
  }
};
</script>
